/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoiceBulkStatusChangeRequest
 */
export interface InvoiceBulkStatusChangeRequest {
    /**
     * 
     * @type {string}
     * @memberof InvoiceBulkStatusChangeRequest
     */
    status?: string;
}

/**
 * Check if a given object implements the InvoiceBulkStatusChangeRequest interface.
 */
export function instanceOfInvoiceBulkStatusChangeRequest(value: object): value is InvoiceBulkStatusChangeRequest {
    return true;
}

export function InvoiceBulkStatusChangeRequestFromJSON(json: any): InvoiceBulkStatusChangeRequest {
    return InvoiceBulkStatusChangeRequestFromJSONTyped(json, false);
}

export function InvoiceBulkStatusChangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceBulkStatusChangeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function InvoiceBulkStatusChangeRequestToJSON(json: any): InvoiceBulkStatusChangeRequest {
    return InvoiceBulkStatusChangeRequestToJSONTyped(json, false);
}

export function InvoiceBulkStatusChangeRequestToJSONTyped(value?: InvoiceBulkStatusChangeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
    };
}

